import React, { useState } from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { Link as MUILink } from '@mui/material';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Tab from '@mui/material/Tab';
import Card from '@mui/material/Card';
import { useTranslation } from 'react-i18next';
import { useLocation, Link } from 'react-router-dom';
import LaboxWS from 'icons/LaboxWS';
import EmailPasswordLoginForm from './EmailPasswordLoginForm';
import SocialSigninCard from './SocialSignInCard';
import CreateAccountForm from './CreateAccountForm';
import PasswordForgottenCard from './PasswordForgottenCard';

export default function SignIn(props) {
  const {
    signinCallback,
  } = props;
  const { t } = useTranslation();
  const location = useLocation();

  const [emailPasswordCardType, setemailPasswordCardType] = useState('signin');
  const [tab, setTab] = useState('signin');
  const [afterSignInRedirect] = useState(
    location.state?.afterSignInRedirect,
  );

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2,
        mt: 3,
        p: 3,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
        }}
      >
        <LaboxWS width="180" />
        <Typography component="span" variant="h6">
          {t('signin.info1')}
          <Typography component="span" variant="h6" sx={{ fontWeight: 'bold', color: '#437A89' }}>
            {t('signin.info2')}
          </Typography>
        </Typography>
      </Box>

      <SocialSigninCard
        signinCallback={signinCallback}
      />

      {emailPasswordCardType === 'signin' && (
      <Card
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          p: 1,
          gap: 1,
          width: { xs: '100%', sm: '88%' },
          maxWidth: 670,
        }}
      >
        <TabContext value={tab}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList onChange={handleTabChange} centered>
              <Tab label={t('signin.login')} value="signin" />
              <Tab label={t('signin.register')} value="register" />
            </TabList>
          </Box>
          <TabPanel value="signin">
            <EmailPasswordLoginForm
              setemailPasswordCardType={setemailPasswordCardType}
              signinCallback={signinCallback}
            />
          </TabPanel>
          <TabPanel value="register">
            <CreateAccountForm
              setemailPasswordCardType={setemailPasswordCardType}
              signinCallback={signinCallback}
            />
          </TabPanel>
        </TabContext>
      </Card>
      )}

      {emailPasswordCardType === 'passwordForgotten' && (
      <PasswordForgottenCard
        setemailPasswordCardType={setemailPasswordCardType}
      />
      )}

      <Typography>
        {t('welcome.contact_message')}
        <MUILink
          component={Link}
          to="/contact"
          color="primary"
          sx={{ fontWeight: 'bold' }}
        >
          contact@labox-apps.com
        </MUILink>
      </Typography>
    </Box>
  );
}
